module.exports = {
  cards: {
    got_it_right: 'Gewusst',
    zoom_in: 'Vergrößern',
    got_it_wrong: 'Nicht gewusst',
    zoom_out: 'Verkleinern',
  },
  flip: 'Umdrehen',
}
